export default "__VITE_ASSET__Dv1Za76H__"